import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'PostCard' })({
    root: {
        display: 'flex',
        padding: 40,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
        borderRadius: 24,
        background: 'rgba(0, 0, 0, 0.15)',
        textDecoration: 'none'
    },
    published: {
        width: 130,
        lineHeight: '21px'
    },
    content: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: '1 0 0'
    },
    tags: {
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 8
    },
    tag: {
        display: 'flex',
        padding: '8px 12px',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 100
    }
});
